import request from 'utils/request'
import { MCAZS150InterviewScheduleRequest } from 'types/MCAZS150/MCAZS150InterviewScheduleRequest'

export const sysVersionNumberCheckRequest = (apiData: MCAZS150InterviewScheduleRequest) =>
  request({
    url: '/MCAZS150/confirm',
    method: 'post',
    data: apiData,
  })
